import React ,{useRef,useEffect} from "react";
import { MdDevices, MdHistory,MdOutlineDisplaySettings, MdSettings, MdWarning, MdSchedule, MdMenu, MdNotifications, MdLogout } from "react-icons/md";
import { useSidebar } from "../Utility/SidebaarContext";
import { useLocation } from "react-router-dom";
import { IoIosArrowForward } from "react-icons/io";
import { FiAlertTriangle } from "react-icons/fi";
import { TbSettingsCog ,TbDeviceAnalytics} from "react-icons/tb";
const CombinedLayout = () => {
   const location = useLocation();
  const { isSidebarExpanded, toggleSidebar } =  useSidebar();
  const sidebarRef = useRef(null);
  const headerRef = useRef(null);


  const menuItems = [
    { id: 1, name: "Devices", href: "/Devices", icon: "Vector.svg" },
    { id: 2, name: "Maintenance Schedules", href: "/maintenance-schedules", icon: "Group.svg" },
    { id: 3, name: "Diagnostics History", href: "/diagnostics-history", icon: "Vector (1).svg" },
    { id: 4, name: "Firmware Update", href: "/Firmware-Update", icon: "Group (1).svg" },
    { id: 5, name: "Alerts", href:  "/alerts", icon: "Vector (2).svg" },
    
  ];

  const topHeaderButtons = [
    { icon: <MdSettings size={30} />, href: "/Firmware-Update", title: "Settings" },
    { icon: <MdNotifications size={30} />, href: "/Notification/av", title: "Notifications" },
    { icon: <MdLogout size={30} />, action: () => console.log("Logging out..."), title: "Sign Out" },
  ];

  const basePath = location.pathname.split('/').slice(0, 2).join('/')




  
   // Close sidebar when clicking outside of the header and sidebar
  // Close sidebar when clicking outside of the header and sidebar
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        sidebarRef.current &&
        !sidebarRef.current.contains(event.target) &&
        headerRef.current &&
        !headerRef.current.contains(event.target)
      ) {
        // Check if the screen width is less than or equal to 768 pixels (mobile)
        if (isSidebarExpanded && window.innerWidth <= 768) {
          toggleSidebar(); // Close the sidebar
        }
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isSidebarExpanded, toggleSidebar]);


  if (basePath === '/') return null;
  
  const pathLabels = {
    '/Devices': 'Device',
    '/maintenance-schedules': 'Maintenance Schedule',
    '/diagnostics-history': 'Diagnostics History',
    '/Firmware-Update': 'Firmware Update',
    '/alerts': 'Alerts',
    '/Notification': 'Notification',
};

const label = pathLabels[basePath] || '';

  return (
    <div className=" md:h-screen flex flex-col   bg-DarkBlue">
      {/* Top Header */}
      
      <header ref={headerRef} className="fixed z-10 top-0 w-full bg-DarkBlue flex justify-between items-center h-[4.5rem] px-4 text-white">
        {/* Logo */}

        {/* Sidebar Header */}
        <div className="flex items-center justify-between  gap-5 p-1">
            <button title="Menu"
              onClick={toggleSidebar}
              className="focus:outline-none text-white"
            >
              <MdMenu size={30} />
            </button>

            <a href="/" className="flex items-center p-1 text-lg font-bold">
          <img
            src="/Icons/brand-logo.svg"
            alt="brand-logo"
            title="Serco-Logo"
            className=" object-contain w-auto"
          />
    
        </a>
          </div>
        

        {/* Top Header Buttons */}

        <h2 className=" text-2xl font-medium">{label}</h2>
        
        <nav className="flex gap-6 items-center">
          {topHeaderButtons.map((button, index) => (
            <a
              key={index}
              href={button.href || "#"}
              onClick={button.action || null}
              className="flex items-center gap-2 hover:text-gray-300 transition-colors"
              title={button.title}
            >
              {button.icon}
            
            </a>
          ))}
        </nav>
      </header>

      <div  ref={sidebarRef} className={`flex max-md:absolute  max-md:z-[500] max-md:pt-0 max-md:top-16  bg-DarkBlue  flex-1 pt-[4.5rem] ${isSidebarExpanded ? '':'max-md:hidden'} `}>
        {/* Sidebar */}
        <aside
          className={`h-full bg-NavyBlue text-white transition-all duration-300 ${
            isSidebarExpanded ? "w-64" : "w-20"
          }`}
        >
          

          {/* Sidebar Menu */}
          <nav className="mt-4 w-full ">
            <ul className="space-y-3 p-1 ">
              {menuItems.map((item) => (
                
                <li  title={item.name} key={item.id} className={`   ${ item.href.split('/').slice(0, 2).join('/') === basePath ? 'border-l-2 border-b-2 b border-red-600':'pl-1'}  rounded-lg shadow-md h-14  `}>
                 
                  <a
                 
                    href={item.href}
                    className="flex items-center   overflow-hidden  h-full px-4   w-full hover:bg-DarkGray transition-colors"
                  >
                    <figure className=" p-1 w-14">
                    <img src={`/SidebaarIcons/${item.icon}`} className=" object-contain" alt={item.name} title={item.name} />
                    </figure>
                    {isSidebarExpanded && (

                      <>
                      <span className=" border-r h-14 mx-2 opacity-50   "></span>
                      <div className=" flex w-full justify-between items-center">
                        
                        <span className=" text-base ">{item.name}  </span>
                      <IoIosArrowForward size={20} />
                      </div>
                      </>
                     
                      
                    )}
                  </a>
                </li>
              ))}
            </ul>
          </nav>
        </aside>

       
      </div>
    </div>
  );
};

export default CombinedLayout;
